// extracted by mini-css-extract-plugin
export default {"header":"Header_header__fquM+","flex":"Header_flex__424yJ","flexcolumn":"Header_flexcolumn__ZWhqK","main-image":"Header_main-image__-kzu5","logo-image":"Header_logo-image__sTebM"};